import {
  DataTableAssign,
  DataTableAssignProps,
} from "@/components/custom/data-table/data-table-assign";
import { SitesTableContext } from "./-sites-table-context";

export function SitesTable(props: Omit<DataTableAssignProps, "context">) {
  return (
    <DataTableAssign
      context={SitesTableContext}
      pageOptions={[50, 100, 200]}
      {...props}
      stickyHeader={true}
    />
  );
}
